export default {
  //get all CHAPTERs
  GET_LIVE_VIDEOS_REQUEST: "GET_LIVE_VIDEOS_REQUEST",
  GET_LIVE_VIDEOS_SUCCESS: "GET_LIVE_VIDEOS_SUCCESS",
  GET_LIVE_VIDEOS_FAIL: "GET_LIVE_VIDEOS_FAIL",

  //create CHAPTER
  CREATE_LIVE_VIDEO_REQUEST: "CREATE_LIVE_VIDEO_REQUEST",
  CREATE_LIVE_VIDEO_SUCCESS: "CREATE_LIVE_VIDEO_SUCCESS",
  CREATE_LIVE_VIDEO_FAIL: "CREATE_LIVE_VIDEO_FAIL",

  LIVE_VIDEO_REPORT_REQUEST: "LIVE_VIDEO_REPORT_REQUEST",
  LIVE_VIDEO_REPORT_SUCCESS: "LIVE_VIDEO_REPORT_SUCCESS",
  LIVE_VIDEO_REPORT_FAIL: "LIVE_VIDEO_REPORT_FAIL",

  TOGGLE_ACTIVE_LIVE_VIDEO_REQUEST: "TOGGLE_ACTIVE_LIVE_VIDEO_REQUEST",
  TOGGLE_ACTIVE_LIVE_VIDEO_SUCCESS: "TOGGLE_ACTIVE_LIVE_VIDEO_SUCCESS",
  TOGGLE_ACTIVE_LIVE_VIDEO_FAIL: "TOGGLE_ACTIVE_LIVE_VIDEO_FAIL",

  UPDATE_LIVE_VIDEO_REQUEST: "UPDATE_LIVE_VIDEO_REQUEST",
  UPDATE_LIVE_VIDEO_SUCCESS: "UPDATE_LIVE_VIDEO_SUCCESS",
  UPDATE_LIVE_VIDEO_FAIL: "UPDATE_LIVE_VIDEO_FAIL",

  DELETE_LIVE_VIDEO_REQUEST: "DELETE_LIVE_VIDEO_REQUEST",
  DELETE_LIVE_VIDEO_SUCCESS: "DELETE_LIVE_VIDEO_SUCCESS",
  DELETE_LIVE_VIDEO_FAIL: "DELETE_LIVE_VIDEO_FAIL",

  LIVE_VIDEO_ABSENCE_REQUEST: "LIVE_VIDEO_ABSENCE_REQUEST",
  LIVE_VIDEO_ABSENCE_SUCCESS: "LIVE_VIDEO_ABSENCE_SUCCESS",
  LIVE_VIDEO_ABSENCE_FAIL: "LIVE_VIDEO_ABSENCE_FAIL",

  UPDATE_STUDENT_LIVE_VIDEO_RECORD_REQUEST: "UPDATE_STUDENT_LIVE_VIDEO_RECORD_REQUEST",
  UPDATE_STUDENT_LIVE_VIDEO_RECORD_SUCCESS: "UPDATE_STUDENT_LIVE_VIDEO_RECORD_SUCCESS",
  UPDATE_STUDENT_LIVE_VIDEO_RECORD_FAIL: "UPDATE_STUDENT_LIVE_VIDEO_RECORD_FAIL",

  //loading
  ADD_LIVE_VIDEOS_LOADING: "ADD_LIVE_VIDEOS_LOADING",
};
